import PasswordChangeForm from './passwordchange_form'
import requireAuth from '../../require-auth'

export default requireAuth(PasswordChangeForm)



// WEBPACK FOOTER //
// ./src/components/pages/password_change/index.ts